import { Typography } from '@mui/material';

export const ActionText = () => {
  return (
    <Typography
      variant="h6"
      gutterBottom
      sx={{
        fontSize: {
          xs: '19px',
          md: '21px',
        },
        display: 'flex',
        flexDirection: 'column',
        fontWeight: '700',
        fontFamily: "'Exo 2', sans-serif",
        color: 'text.primary',
        wordWrap: 'break-word',
        textAlign: 'center',
        margin: '0px',
        maxWidth: '700px',
      }}
    >
      Напиши в любой мессенджер и забери <span>купон 3000 руб. на первое посещение RSL-массажа</span>
    </Typography>
  );
};
